import CryptoJS from 'crypto-js'

/**
 * AES 解密工具
 * 与后端加密算法对应
 */

// 密钥（必须与后端配置一致，32字节 AES-256）
const SECRET_KEY = 'geek-coding-2024-8f3b9a1c7e4d2xx'

/**
 * AES 解密
 * @param {string} encryptedData - Base64 编码的加密字符串
 * @param {string} key - 密钥（可选，默认使用 SECRET_KEY）
 * @returns {string} 解密后的字符串
 */
export function decrypt(encryptedData, key = SECRET_KEY) {
    try {
        // 使用密钥的前16位作为 IV（与后端保持一致）
        const keyBytes = CryptoJS.enc.Utf8.parse(key)
        const ivBytes = CryptoJS.enc.Utf8.parse(key.substring(0, 16))

        // 解密
        const decrypted = CryptoJS.AES.decrypt(encryptedData, keyBytes, {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })

        // 转为 UTF-8 字符串
        return decrypted.toString(CryptoJS.enc.Utf8)
    } catch (error) {
        console.error('AES 解密失败:', error)
        throw error
    }
}

/**
 * AES 加密（如果需要加密请求参数）
 * @param {string} content - 待加密内容
 * @param {string} key - 密钥（可选，默认使用 SECRET_KEY）
 * @returns {string} Base64 编码的加密字符串
 */
export function encrypt(content, key = SECRET_KEY) {
    try {
        // 使用密钥的前16位作为 IV
        const keyBytes = CryptoJS.enc.Utf8.parse(key)
        const ivBytes = CryptoJS.enc.Utf8.parse(key.substring(0, 16))

        // 加密
        const encrypted = CryptoJS.AES.encrypt(content, keyBytes, {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })

        // 返回 Base64 字符串
        return encrypted.toString()
    } catch (error) {
        console.error('AES 加密失败:', error)
        throw error
    }
}
